"use client"

import { motion } from "framer-motion"

const HeroSection = () => {
  return (
    <section id="home" className="relative min-h-[92vh] flex items-center overflow-hidden">

      {/* Photo Background */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="/images/hero-family-sunset.jpg"
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover object-center hero-kenburns"
          loading="eager"
          decoding="async"
          fetchPriority="high"
          width={1920}
          height={1280}
        />
        {/* Dark blue overlay */}
        <div
          className="absolute inset-0"
          style={{ background: "hsl(222 48% 18% / 0.62)" }}
        />
        {/* Left-side gradient for text contrast */}
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(105deg, hsl(222 48% 12% / 0.55) 0%, hsl(222 48% 12% / 0.2) 60%, transparent 100%)",
          }}
        />
        {/* Warm golden radial tint — upper right */}
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse 70% 45% at 85% 5%, rgba(210,160,80,0.12) 0%, transparent 60%)",
          }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-36 md:py-44">
        <div className="max-w-2xl">

          <motion.h1
            initial={{ opacity: 0, y: 28 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.32, duration: 0.75 }}
            className="font-heading text-4xl sm:text-5xl lg:text-[3.4rem] font-semibold leading-tight text-white mb-5"
          >
            Stop Fighting the Same{" "}
            <em className="not-italic text-[hsl(var(--sage-light))]">
              Battles Alone
            </em>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.7 }}
            className="text-base sm:text-lg text-white leading-relaxed mb-10 max-w-xl font-body drop-shadow-md"
          >
            Are you struggling with anxiety, grief, addiction, past trauma, or major life changes? Our licensed trauma therapists in Greensboro offer personalized therapy, EMDR treatment, and intensive programs to guide you toward faster, lasting healing.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.75, duration: 0.6 }}
            className="flex flex-col sm:flex-row gap-4"
          >
            <a
              href="/book-a-session"
              className="inline-flex items-center justify-center rounded-full bg-[hsl(var(--terracotta))] text-white px-9 py-4 text-base font-semibold tracking-wide hover:bg-[hsl(var(--terracotta))]/90 transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5"
            >
              BOOK A SESSION
            </a>
            <a
              href="/contact"
              className="inline-flex items-center justify-center rounded-full border border-white/50 text-white px-9 py-4 text-base font-medium tracking-wide hover:bg-white/10 transition-all"
            >
              CONTACT US
            </a>
          </motion.div>
        </div>
      </div>

      {/* Animated scroll arrow */}
      <motion.div
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-1"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 0.6 }}
      >
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
        >
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="opacity-70"
          >
            <path
              d="M6 10L14 18L22 10"
              stroke="white"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </motion.div>
      </motion.div>

      {/* Curved bottom edge */}
      <div className="absolute bottom-0 left-0 right-0 z-10 overflow-hidden leading-none">
        <svg
          viewBox="0 0 1440 72"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          className="block w-full"
          style={{ height: "72px" }}
        >
          <path
            d="M0,72 C360,0 1080,0 1440,72 L1440,72 L0,72 Z"
            fill="hsl(var(--background))"
          />
        </svg>
      </div>

    </section>
  )
}

export default HeroSection
